import type { ISchemaWithText } from "~/models/IUserEntry";

const parseHtml = (function () {
  if (import.meta.env.SSR) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { parseHTML } = require("linkedom");
    return (html: string) => {
      const { document } = parseHTML(`<!DOCTYPE html>${html}`);
      return document.querySelector("section");
    };
  }
  return (html: string) => {
    const tmpl = document.createElement("div");
    tmpl.innerHTML = html;
    return tmpl.firstElementChild;
  };
})();

export function useSchemaSummary(schema: ISchemaWithText) {
  const trimmed = schema.text.trim() ?? "";
  const el = parseHtml(trimmed);

  if (el?.getAttribute("data-style") === "summary") {
    return el.textContent?.trim();
  }
  return null;
}
